var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4819 17.1164C23.8619 19.5966 20.0016 18.3365 18.8015 17.9965L19.9016 13.6362C21.1417 13.9962 25.122 14.5162 24.4819 17.1164ZM18.2615 20.2366L17.0614 25.057C18.5415 25.437 23.1218 26.8971 23.8019 24.1769C24.5219 21.3367 19.7416 20.5967 18.2615 20.2366ZM39.403 24.837C36.7228 35.5577 25.882 42.0782 15.1613 39.398C4.4405 36.7178 -2.07396 25.877 0.600228 15.1563C1.23556 12.6083 2.36662 10.2104 3.9288 8.09957C5.49099 5.98875 7.4537 4.20636 9.70484 2.8542C11.956 1.50203 14.4514 0.606577 17.0487 0.218981C19.6459 -0.168615 22.2941 -0.0407604 24.8419 0.595242C35.5427 3.27543 42.0632 14.1162 39.403 24.837ZM24.4219 12.0961L25.322 8.4958L23.1218 7.99577L22.2418 11.456C21.6617 11.316 21.0817 11.176 20.4816 11.056L21.3617 7.51573L19.1815 6.9957L18.2815 10.5759C17.8014 10.4559 17.3214 10.3559 16.8814 10.2359L13.8612 9.47587L13.2611 11.816C13.2611 11.816 14.9012 12.1961 14.8612 12.2161C15.7613 12.4361 15.9213 12.9961 15.8813 13.4962L13.4211 23.3569C13.3211 23.6369 13.0011 23.9969 12.4211 23.8969C12.4411 23.9169 10.821 23.4969 10.821 23.4969L9.74088 25.997L12.5811 26.7171C13.1211 26.8571 13.6412 26.9971 14.1612 27.1171L13.2411 30.7574L15.4413 31.3174L16.3413 27.6972C16.9414 27.8572 17.5214 27.9972 18.0815 28.1572L17.1814 31.7374L19.3816 32.2975L20.3016 28.6572C24.0019 29.3573 26.8421 29.0773 28.0022 25.697C29.0022 22.9968 28.0022 21.3967 26.002 20.3766C27.4421 19.9966 28.5222 19.0966 28.8222 17.1364C29.2223 14.4762 27.1821 13.0561 24.4219 12.0961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.e4691091511ae9d8b6794108a941263b.svg";
export { ForwardRef as ReactComponent };